import React from 'react'

function Services({ children, backgroundColor, colorTitle, id }) {
  return (
    <div
      id={id}
      className="flex-center flex-column flex__gap-50 padding-100 background-light"
      style={{ background: backgroundColor }}
    >
      <h2 className="title-main text-dark" style={{ color: colorTitle }}>
        Produtos e Serviços
      </h2>
      <div className="container-cards-services flex-center flex__gap-20 flex__wrap">
        {children}
      </div>
    </div>
  )
}

export default Services
